import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useRawTable } from "../../hooks";
import {
  option_chronic_disease,
  option_chronic_disease_obj,
} from "../../../service/option/common";
import { decimalAddZero } from "../../../service/common";
import moment from "moment";

export default function Module_ElderlyHealth_ChronicDiseaseTypeStatistic({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const redux_diagram = useSelector((state) => state.diagram);
  const [diseaseType, setDiseaseType] = useState([]);
  const moduleDataTemp = useMemo(
    () => ({
      ...moduleData,
      columns: [
        {
          key: "type",
          field: "type",
          header: "慢性病種類",
        },
        ...(diseaseType || []).map((item) => ({
          key: item,
          field: item,
          header: item,
        })),
        {
          key: "total",
          field: "total",
          header: "病徵數小計",
        },
      ],
    }),
    [moduleData, diseaseType]
  );
  const { setTbData, renderTable } = useRawTable({
    setting: moduleDataTemp,
    nullTransfer: "-",
    subTitleBgColor: "elderlytitle1",
  });
  const filterYear =
    redux_diagram.filterSetting?.ChronicDiseaseTypeStatistic?.noback_year
      ?.value ?? Number(moment().format("YYYY"));

  useEffect(() => {
    if (!apiData) return;

    let formatData = apiData
      .filter((item) =>
        [filterYear, filterYear - 1911].includes(Number(item["篩檢年份"]))
      )
      .reduce((pre, cur) => ({ ...pre, [cur["個案ID"]]: cur }), {});
    formatData = Object.values(formatData);

    let data = { count: { total: 0 }, percent: {} },
      otherType = {},
      type = formatData.reduce((pre, cur) => {
        // 主要病徵
        let statistic = cur["慢性疾病統計"]?.split("#").reduce((preS, curS) => {
            let key = option_chronic_disease_obj[curS].realLabel;

            if (!data.count[key]) data.count[key] = 0;
            data.count[key]++;
            data.count.total++;

            return {
              ...preS,
              [key]: 1,
            };
          }, {}),
          temp = {
            ...statistic,
          };

        // 其他病徵
        otherType = {
          ...otherType,
          ...[
            ...(cur["慢性疾病統計其他"] ? [cur["慢性疾病統計其他"]] : []),
            ...(cur["慢性疾病統計癌症"] ? [cur["慢性疾病統計癌症"]] : []),
            // ...(cur["慢性疾病統計其他"]
            //   ? cur["慢性疾病統計其他"].indexOf("、") !== -1
            //     ? cur["慢性疾病統計其他"].split("、")
            //     : cur["慢性疾病統計其他"].split("、") // " "
            //   : []),
            // ...(cur["慢性疾病統計癌症"]
            //   ? cur["慢性疾病統計癌症"].indexOf("、") !== -1
            //     ? cur["慢性疾病統計癌症"].split("、")
            //     : cur["慢性疾病統計癌症"].split("、") // " "
            //   : []),
          ].reduce((preO, curO) => {
            if (!data.count[curO]) data.count[curO] = 0;
            data.count[curO]++;
            data.count.total++;

            return {
              ...preO,
              [curO]: 1,
            };
          }, {}),
        };

        return {
          ...pre,
          ...temp,
        };
      }, {});
    delete type["無"];
    delete type["其他"];
    type = Object.keys({ ...type, ...otherType });
    setDiseaseType(type);

    data.percent = {
      ...Object.entries(data.count).reduce(
        (pre, [curKey, curVal]) => ({
          ...pre,
          [curKey]: `${Math.round((curVal / data.count.total) * 1000) / 10}%`,
        }),
        {}
      ),
      type: "占比(%)",
    };

    setTbData({
      raw: [
        {
          ...Object.entries(data.count).reduce(
            (pre, [curKey, curVal]) => ({
              ...pre,
              [curKey]:
                typeof curVal === "number"
                  ? decimalAddZero({
                      rawVal: curVal ?? 0,
                      decimalShowRaw: true,
                    })
                  : curVal,
            }),
            {}
          ),
          type: "病徵數",
        },
        data.percent,
      ],
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: `${moduleData.label}(${filterYear})`,
      })}
    </>
  );
}
